import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "outercontent"
};
const _hoisted_2 = {
  class: "innercontent"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "el-upload-list__item-actions"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "el-upload-list__item-actions"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "el-upload-list__item-actions"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "el-upload-list__item-actions"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "el-upload-list__item-actions"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = {
  class: "offsetul"
};
const _hoisted_21 = {
  class: "offsetul"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = ["src"];
const _hoisted_24 = ["innerHTML"];
const _hoisted_25 = {
  class: "bottombox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_button = _resolveComponent("el-button");
  const _component_Delete = _resolveComponent("Delete");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_color_picker = _resolveComponent("el-color-picker");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
    ref: "form",
    model: $data.form,
    "label-width": "126px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: $data.formlabel.title,
      prop: "title",
      rules: [{
        required: true,
        message: `请填写${$data.formlabel.title}`
      }]
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.title,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.title = $event),
        onChange: _cache[1] || (_cache[1] = $event => $options.blurInput($event, 'title'))
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label", "rules"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.toptitle,
      prop: "toptitle",
      rules: [{
        required: true,
        message: `请填写${$data.formlabel.toptitle}`
      }]
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.toptitle,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.toptitle = $event),
        onChange: _cache[3] || (_cache[3] = $event => $options.blurInput($event, 'toptitle'))
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label", "rules"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.logo
    }, {
      default: _withCtx(() => [_createVNode(_component_el_upload, {
        class: "uploadbox",
        onClick: _cache[4] || (_cache[4] = $event => $options.uploadClick('logo')),
        "file-list": $data.dfileList.logo,
        "onUpdate:fileList": _cache[5] || (_cache[5] = $event => $data.dfileList.logo = $event),
        "list-type": "picture-card",
        "auto-upload": false,
        action: "#",
        "on-change": $options.uploadChange,
        limit: 1
      }, {
        file: _withCtx(({
          file
        }) => [_createElementVNode("div", null, [_createElementVNode("img", {
          class: "el-upload-list__item-thumbnail",
          src: file.url,
          alt: ""
        }, null, 8, _hoisted_3), _createElementVNode("span", _hoisted_4, [_createElementVNode("span", {
          class: "el-upload-list__item-delete",
          onClick: $event => $options.handleRemove(file, 'logo')
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Delete)]),
          _: 1
        })], 8, _hoisted_5)])])]),
        default: _withCtx(() => [_createVNode(_component_el_button, null, {
          default: _withCtx(() => _cache[63] || (_cache[63] = [_createTextVNode("上传")])),
          _: 1
        })]),
        _: 1
      }, 8, ["file-list", "on-change"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.pickey
    }, {
      default: _withCtx(() => [_createVNode(_component_el_upload, {
        class: "uploadbox",
        onClick: _cache[6] || (_cache[6] = $event => $options.uploadClick('pickey')),
        "file-list": $data.dfileList.pickey,
        "onUpdate:fileList": _cache[7] || (_cache[7] = $event => $data.dfileList.pickey = $event),
        "list-type": "picture-card",
        "auto-upload": false,
        action: "#",
        "on-change": $options.uploadChange,
        limit: 1
      }, {
        file: _withCtx(({
          file
        }) => [_createElementVNode("div", null, [_createElementVNode("img", {
          class: "el-upload-list__item-thumbnail",
          src: file.url,
          alt: ""
        }, null, 8, _hoisted_6), _createElementVNode("span", _hoisted_7, [_createElementVNode("span", {
          class: "el-upload-list__item-delete",
          onClick: $event => $options.handleRemove(file, 'pickey')
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Delete)]),
          _: 1
        })], 8, _hoisted_8)])])]),
        default: _withCtx(() => [_createVNode(_component_el_button, null, {
          default: _withCtx(() => _cache[64] || (_cache[64] = [_createTextVNode("上传")])),
          _: 1
        })]),
        _: 1
      }, 8, ["file-list", "on-change"])]),
      _: 1
    }, 8, ["label"]), _withDirectives(_createVNode(_component_el_form_item, {
      label: $data.formlabel.background_img
    }, {
      default: _withCtx(() => [_createVNode(_component_el_upload, {
        class: "uploadbox",
        onClick: _cache[8] || (_cache[8] = $event => $options.uploadClick('background_img')),
        "file-list": $data.dfileList.background_img,
        "onUpdate:fileList": _cache[9] || (_cache[9] = $event => $data.dfileList.background_img = $event),
        "list-type": "picture-card",
        "auto-upload": false,
        action: "#",
        "on-change": $options.uploadChange,
        limit: 1
      }, {
        file: _withCtx(({
          file
        }) => [_createElementVNode("div", null, [_createElementVNode("img", {
          class: "el-upload-list__item-thumbnail",
          src: file.url,
          alt: ""
        }, null, 8, _hoisted_9), _createElementVNode("span", _hoisted_10, [_createElementVNode("span", {
          class: "el-upload-list__item-delete",
          onClick: $event => $options.handleRemove(file, 'background_img')
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Delete)]),
          _: 1
        })], 8, _hoisted_11)])])]),
        default: _withCtx(() => [_createVNode(_component_el_button, null, {
          default: _withCtx(() => _cache[65] || (_cache[65] = [_createTextVNode("上传")])),
          _: 1
        })]),
        _: 1
      }, 8, ["file-list", "on-change"])]),
      _: 1
    }, 8, ["label"]), [[_vShow, !$props.ispc]]), _withDirectives(_createVNode(_component_el_form_item, {
      label: $data.formlabel.app_bg_img
    }, {
      default: _withCtx(() => [_createVNode(_component_el_upload, {
        class: "uploadbox",
        onClick: _cache[10] || (_cache[10] = $event => $options.uploadClick('app_bg_img')),
        "file-list": $data.dfileList.app_bg_img,
        "onUpdate:fileList": _cache[11] || (_cache[11] = $event => $data.dfileList.app_bg_img = $event),
        "list-type": "picture-card",
        "auto-upload": false,
        action: "#",
        "on-change": $options.uploadChange,
        limit: 1
      }, {
        file: _withCtx(({
          file
        }) => [_createElementVNode("div", null, [_createElementVNode("img", {
          class: "el-upload-list__item-thumbnail",
          src: file.url,
          alt: ""
        }, null, 8, _hoisted_12), _createElementVNode("span", _hoisted_13, [_createElementVNode("span", {
          class: "el-upload-list__item-delete",
          onClick: $event => $options.handleRemove(file, 'app_bg_img')
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Delete)]),
          _: 1
        })], 8, _hoisted_14)])])]),
        default: _withCtx(() => [_createVNode(_component_el_button, null, {
          default: _withCtx(() => _cache[66] || (_cache[66] = [_createTextVNode("上传")])),
          _: 1
        })]),
        _: 1
      }, 8, ["file-list", "on-change"])]),
      _: 1
    }, 8, ["label"]), [[_vShow, $props.ispc]]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.mapmodetype,
      prop: "mapmodetype",
      onChange: _cache[13] || (_cache[13] = $event => $options.blurInput($event, 'mapmodetype'))
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.mapmodetype,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.form.mapmodetype = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.formoption.mapmodetype, (item, index) => {
          return _openBlock(), _createBlock(_component_el_radio, {
            key: item.title,
            label: item.title
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), $data.sectionStatus === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_el_form_item, {
      label: $data.formlabel.static_img
    }, {
      default: _withCtx(() => [_createVNode(_component_el_upload, {
        class: "uploadbox",
        onClick: _cache[14] || (_cache[14] = $event => $options.uploadClick('static_img')),
        "file-list": $data.dfileList.static_img,
        "onUpdate:fileList": _cache[15] || (_cache[15] = $event => $data.dfileList.static_img = $event),
        "list-type": "picture-card",
        "auto-upload": false,
        action: "#",
        "on-change": $options.uploadChange,
        limit: 1
      }, {
        file: _withCtx(({
          file
        }) => [_createElementVNode("div", null, [_createElementVNode("img", {
          class: "el-upload-list__item-thumbnail",
          src: file.url,
          alt: ""
        }, null, 8, _hoisted_16), _createElementVNode("span", _hoisted_17, [_createElementVNode("span", {
          class: "el-upload-list__item-delete",
          onClick: $event => $options.handleRemove(file, 'static_img')
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Delete)]),
          _: 1
        })], 8, _hoisted_18)])])]),
        default: _withCtx(() => [_createVNode(_component_el_button, null, {
          default: _withCtx(() => _cache[67] || (_cache[67] = [_createTextVNode("上传")])),
          _: 1
        })]),
        _: 1
      }, 8, ["file-list", "on-change"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.static_map_min_level,
      prop: "static_map_min_level"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.form.static_map_min_level,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.form.static_map_min_level = $event),
        class: "m-2",
        placeholder: "请选择",
        onChange: _cache[17] || (_cache[17] = $event => $options.blurInput($event, 'static_map_min_level', 'mapParam'))
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.formoption.static_map_min_level, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.title,
            label: item.title,
            value: item.title
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.static_map_max_level,
      prop: "static_map_max_level"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.form.static_map_max_level,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.form.static_map_max_level = $event),
        class: "m-2",
        placeholder: "请选择",
        onChange: _cache[19] || (_cache[19] = $event => $options.blurInput($event, 'static_map_max_level', 'mapParam'))
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.formoption.static_map_min_level, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.title,
            label: item.title,
            value: item.title
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"])])) : _createCommentVNode("", true), $data.sectionStatus === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_el_form_item, {
      label: $data.formlabel.map_min_level,
      prop: "map_min_level"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.form.map_min_level,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.form.map_min_level = $event),
        class: "m-2",
        placeholder: "请选择",
        onChange: _cache[21] || (_cache[21] = $event => $options.blurInput($event, 'map_min_level', 'mapParam'))
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.formoption.map_min_level, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.title,
            label: item.title,
            value: item.title
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.map_max_level,
      prop: "map_max_level"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.form.map_max_level,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.form.map_max_level = $event),
        class: "m-2",
        placeholder: "请选择",
        onChange: _cache[23] || (_cache[23] = $event => $options.blurInput($event, 'map_max_level', 'mapParam'))
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.formoption.map_max_level, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.title,
            label: item.title,
            value: item.title
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"])])) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_el_form_item, {
      label: $data.formlabel.current_level,
      prop: "current_level"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.form.current_level,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.form.current_level = $event),
        class: "m-2",
        placeholder: "请选择",
        onChange: _cache[25] || (_cache[25] = $event => $options.blurInput($event, 'current_level', 'mapParam'))
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.leveloptions, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.title,
            label: item.title,
            value: item.title
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), [[_vShow, !$props.ispc]]), _withDirectives(_createVNode(_component_el_form_item, {
      label: $data.formlabel.app_current_level,
      prop: "app_current_level"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.form.app_current_level,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $data.form.app_current_level = $event),
        class: "m-2",
        placeholder: "请选择",
        onChange: _cache[27] || (_cache[27] = $event => $options.blurInput($event, 'app_current_level', 'mapParam'))
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.leveloptions, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.title,
            label: item.title,
            value: item.title
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), [[_vShow, $props.ispc]]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.transform_extent,
      prop: "transform_extent",
      rules: [{
        required: true,
        message: `请填写${$data.formlabel.transform_extent}`
      }]
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.transform_extent,
        "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => $data.form.transform_extent = $event),
        onChange: _cache[29] || (_cache[29] = $event => $options.blurInput($event, 'transform_extent'))
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label", "rules"]), _withDirectives(_createVNode(_component_el_form_item, {
      label: $data.formlabel.map_center,
      prop: "map_center",
      onChange: _cache[32] || (_cache[32] = $event => $options.blurInput($event, 'map_center', 'mapParam'))
    }, {
      default: _withCtx(() => [_createElementVNode("ul", _hoisted_20, [_createElementVNode("li", null, [_cache[68] || (_cache[68] = _createElementVNode("label", null, "X轴", -1)), _createVNode(_component_el_input_number, {
        modelValue: $data.form.map_centerX,
        "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => $data.form.map_centerX = $event),
        min: 0,
        max: 480
      }, null, 8, ["modelValue"])]), _createElementVNode("li", null, [_cache[69] || (_cache[69] = _createElementVNode("label", null, "Y轴", -1)), _createVNode(_component_el_input_number, {
        modelValue: $data.form.map_centerY,
        "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => $data.form.map_centerY = $event),
        min: 0,
        max: 480
      }, null, 8, ["modelValue"])])]), _cache[70] || (_cache[70] = _createElementVNode("div", {
        class: "description"
      }, "说明：XY轴范围0 ~ 480", -1))]),
      _: 1
    }, 8, ["label"]), [[_vShow, !$props.ispc]]), _withDirectives(_createVNode(_component_el_form_item, {
      label: $data.formlabel.app_map_center,
      prop: "app_map_center",
      onChange: _cache[35] || (_cache[35] = $event => $options.blurInput($event, 'app_map_center', 'mapParam'))
    }, {
      default: _withCtx(() => [_createElementVNode("ul", _hoisted_21, [_createElementVNode("li", null, [_cache[71] || (_cache[71] = _createElementVNode("label", null, "X轴", -1)), _createVNode(_component_el_input_number, {
        modelValue: $data.form.map_centerX,
        "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => $data.form.map_centerX = $event),
        min: 0,
        max: 480
      }, null, 8, ["modelValue"])]), _createElementVNode("li", null, [_cache[72] || (_cache[72] = _createElementVNode("label", null, "Y轴", -1)), _createVNode(_component_el_input_number, {
        modelValue: $data.form.map_centerY,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => $data.form.map_centerY = $event),
        min: 0,
        max: 480
      }, null, 8, ["modelValue"])])]), _cache[73] || (_cache[73] = _createElementVNode("div", {
        class: "description"
      }, "说明：XY轴范围0 ~ 480", -1))]),
      _: 1
    }, 8, ["label"]), [[_vShow, $props.ispc]]), _createVNode(_component_el_form_item, {
      label: "禁止缩放",
      prop: "dragazoom",
      onChange: _cache[37] || (_cache[37] = $event => $options.blurInput($event, 'dragazoom'))
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.dragazoom,
        "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => $data.form.dragazoom = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "是"
        }, {
          default: _withCtx(() => _cache[74] || (_cache[74] = [_createTextVNode("是")])),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "否"
        }, {
          default: _withCtx(() => _cache[75] || (_cache[75] = [_createTextVNode("否")])),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "禁止旋转",
      prop: "dragrotate",
      onChange: _cache[39] || (_cache[39] = $event => $options.blurInput($event, 'dragrotate'))
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.dragrotate,
        "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => $data.form.dragrotate = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "是"
        }, {
          default: _withCtx(() => _cache[76] || (_cache[76] = [_createTextVNode("是")])),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "否"
        }, {
          default: _withCtx(() => _cache[77] || (_cache[77] = [_createTextVNode("否")])),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _cache[88] || (_cache[88] = _createElementVNode("div", {
      class: "pubtitle"
    }, "点位设置", -1)), _createVNode(_component_el_form_item, {
      label: "点位图标",
      prop: "pointIcon"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.pointIcon,
        "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => $data.form.pointIcon = $event),
        class: "ml-4",
        onChange: $options.pointIconChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "是"
        }, {
          default: _withCtx(() => _cache[78] || (_cache[78] = [_createTextVNode("显示")])),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "否"
        }, {
          default: _withCtx(() => _cache[79] || (_cache[79] = [_createTextVNode("隐藏")])),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "onChange"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: $data.formlabel.location_title,
      prop: "34"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.location_title,
        "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => $data.form.location_title = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.formoption.location_title, item => {
          return _openBlock(), _createBlock(_component_el_radio, {
            label: item.title
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["label"]);
        }), 256)), _createVNode(_component_el_radio, {
          label: "2",
          disabled: $data.pointIcondisabled
        }, {
          default: _withCtx(() => _cache[80] || (_cache[80] = [_createTextVNode("鼠标移入显示")])),
          _: 1
        }, 8, ["disabled"])]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_form_item, {
      label: "文字样式",
      prop: "title_font"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.title_font,
        "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => $data.form.title_font = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "文字颜色",
      prop: "title_color"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_color_picker, {
        modelValue: $data.form.title_color,
        "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => $data.form.title_color = $event),
        "show-alpha": ""
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "文字背景",
      prop: "title_bgcolor"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_color_picker, {
        modelValue: $data.form.title_bgcolor,
        "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => $data.form.title_bgcolor = $event),
        "show-alpha": ""
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "文字描边",
      prop: "title_bocolor"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_color_picker, {
        modelValue: $data.form.title_bocolor,
        "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => $data.form.title_bocolor = $event),
        "show-alpha": ""
      }, null, 8, ["modelValue"])]),
      _: 1
    })], 512), [[_vShow, $data.form.location_title !== '隐藏']]), _createVNode(_component_el_form_item, {
      label: "点位图片",
      prop: "pointImg"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.pointImg,
        "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => $data.form.pointImg = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "是"
        }, {
          default: _withCtx(() => _cache[81] || (_cache[81] = [_createTextVNode("显示")])),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "否"
        }, {
          default: _withCtx(() => _cache[82] || (_cache[82] = [_createTextVNode("隐藏")])),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "2",
          disabled: $data.pointIcondisabled
        }, {
          default: _withCtx(() => _cache[83] || (_cache[83] = [_createTextVNode("鼠标移入显示")])),
          _: 1
        }, 8, ["disabled"])]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _withDirectives(_createVNode(_component_el_form_item, {
      label: "图片尺寸",
      prop: "dotimgW"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input_number, {
        "controls-position": "right",
        modelValue: $data.form.dotimgW,
        "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => $data.form.dotimgW = $event),
        min: 0
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 512), [[_vShow, !$props.ispc]]), _withDirectives(_createVNode(_component_el_form_item, {
      label: "图片尺寸",
      prop: "appimgW"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input_number, {
        "controls-position": "right",
        modelValue: $data.form.appimgW,
        "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => $data.form.appimgW = $event),
        min: 0
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 512), [[_vShow, $props.ispc]]), _createVNode(_component_el_form_item, {
      label: "名称与图片间距",
      prop: "title_mtp"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input_number, {
        "controls-position": "right",
        modelValue: $data.form.title_mtp,
        "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => $data.form.title_mtp = $event),
        min: 0
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "弹窗模板",
      prop: "modeltype"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.modeltype,
        "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => $data.form.modeltype = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.popOption, item => {
          return _openBlock(), _createElementBlock("li", null, [_createElementVNode("img", {
            src: item.imgPath,
            alt: ""
          }, null, 8, _hoisted_22), _createVNode(_component_el_radio, {
            label: item.title
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["label"])]);
        }), 256))])]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), $data.form.modeltype === '模板3' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 2,
      label: "弹窗主题色",
      prop: "color_theme1"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_color_picker, {
        modelValue: $data.form.color_theme1,
        "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => $data.form.color_theme1 = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
      label: "是否显示分类",
      prop: "typeflag",
      onChange: _cache[53] || (_cache[53] = $event => $options.blurInput($event, 'typeflag'))
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.typeflag,
        "onUpdate:modelValue": _cache[52] || (_cache[52] = $event => $data.form.typeflag = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "是"
        }, {
          default: _withCtx(() => _cache[84] || (_cache[84] = [_createTextVNode("是")])),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "否"
        }, {
          default: _withCtx(() => _cache[85] || (_cache[85] = [_createTextVNode("否")])),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "分类模板",
      prop: "typemodel"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.typemodel,
        "onUpdate:modelValue": _cache[54] || (_cache[54] = $event => $data.form.typemodel = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.typeOption, item => {
          return _openBlock(), _createElementBlock("li", null, [_createElementVNode("img", {
            src: item.imgPath,
            alt: ""
          }, null, 8, _hoisted_23), _createVNode(_component_el_radio, {
            label: item.title
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["label"])]);
        }), 256))])]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "分类orderBy",
      prop: "typeorderBy"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.typeorderBy,
        "onUpdate:modelValue": _cache[55] || (_cache[55] = $event => $data.form.typeorderBy = $event),
        onChange: _cache[56] || (_cache[56] = $event => $options.blurInput($event, 'typeorderBy'))
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "分类orderType",
      prop: "typeorderType"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.typeorderType,
        "onUpdate:modelValue": _cache[57] || (_cache[57] = $event => $data.form.typeorderType = $event),
        onChange: _cache[58] || (_cache[58] = $event => $options.blurInput($event, 'typeorderType'))
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "底部信息",
      prop: "copyright"
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: "introduce",
        contenteditable: "true",
        innerHTML: $data.form.copyright
      }, null, 8, _hoisted_24)]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "是否开启访问量",
      prop: "viewflag",
      onChange: _cache[60] || (_cache[60] = $event => $options.blurInput($event, 'viewflag'))
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.viewflag,
        "onUpdate:modelValue": _cache[59] || (_cache[59] = $event => $data.form.viewflag = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "是"
        }, {
          default: _withCtx(() => _cache[86] || (_cache[86] = [_createTextVNode("是")])),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "否"
        }, {
          default: _withCtx(() => _cache[87] || (_cache[87] = [_createTextVNode("否")])),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _withDirectives(_createVNode(_component_el_form_item, {
      label: "真实访问量"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        placeholder: $data.viewCount,
        disabled: ""
      }, null, 8, ["placeholder"])]),
      _: 1
    }, 512), [[_vShow, $data.form.viewflag === '是']]), _withDirectives(_createVNode(_component_el_form_item, {
      label: "自定义访问量增量",
      prop: "viewplus"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.viewplus,
        "onUpdate:modelValue": _cache[61] || (_cache[61] = $event => $data.form.viewplus = $event),
        onChange: _cache[62] || (_cache[62] = $event => $options.blurInput($event, 'viewplus'))
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 512), [[_vShow, $data.form.viewflag === '是']])]),
    _: 1
  }, 8, ["model"])]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_button, {
    type: "primary",
    onClick: $options.basicHandle
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.isAddOrEdit ? '提交' : '更新'), 1)]),
    _: 1
  }, 8, ["onClick"])])]);
}